export enum DialogKey {
  AUTH_SIGN_IN = 'sign-in',
  AUTH_BECOME_MEMBER = 'become-member',
  AUTH_BECOME_MEMBER_WHY = 'become-member-why',
  AUTH_BECOME_MEMBER_THANKS = 'become-member-thanks',
  AUTH_BECOME_MEMBER_ROLES = 'become-member-roles',
  AUTH_FORGOT_PASSWORD = 'forgot-password',
  AUTH_FORGOT_PASSWORD_OK = 'forgot-password-ok',
  AUTH_RESET_PASSWORD = 'reset-password',
  AUTH_RESET_PASSWORD_OK = 'reset-password-ok',
  EDITOR_NEW_MESSAGE = 'editor-new-message',
  AUTH_EMAIL_VERIFIER = 'verify-email',
  AUTH_EMAIL_VERIFIER_ASK = 'email-verifier-ask',
}
